export default function berechnungUtils(): any {
  /* Berechnungen */
  function ermittleVersicherungssumme(wohnflaeche: number, multiplikator = 650): number {
    return wohnflaeche * multiplikator;
  }
  return { ermittleVersicherungssumme };
}
